import { TFunction } from 'next-i18next';
import { TNamespaceEnum } from 'types/types';
import { getTranslation } from 'utils/localization';

export const countryFromCode = (
    t: TFunction,
    countryCode: string,
    placeholder = '-'
): string => {
    if (!countryCode) {
        return placeholder;
    }

    return getTranslation(t, TNamespaceEnum.countries, countryCode);
};
